import React from 'react';
import { useFocusedWorkspaceSelector } from '../../features/home/hooks/use-view';
import { useAppDispatch } from '../../hooks/store-hooks';
import { patchFocusedWorkspaceView } from '../../state/store';
import { Command } from './types';

export function useFilterCommands(): Command[] {
    const dispatch = useAppDispatch();
    const filters = useFocusedWorkspaceSelector((x) => x.view.plane.filter.planeFilterSettings);

    return React.useMemo<Command[]>(
        () =>
            filters.map((filter, index) => ({
                id: `filter-${index}-${filter.name}`,
                title: `Filter: ${filter.name}`,
                keywords: ['filter', 'aircraft', filter.name],
                group: 'Filters',
                checked: filter.isActive,
                run: () =>
                    dispatch(
                        patchFocusedWorkspaceView((v) => {
                            v.plane.filter.planeFilterSettings[index].isActive = !v.plane.filter.planeFilterSettings[index].isActive;
                        })
                    )
            })),
        [filters, dispatch]
    );
}
